import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
import queryString from 'query-string';
import { Button, Input, message } from 'antd';
import useInput from '../../../../hooks/useInput';
import { authApi } from '../../../../apis';

/**
 * 패스워드 변경 페이지
 * @author
 * */
const ChangePassword = (props) => {
  // const navigate = useNavigate();
  // const { id: email, token } = useParams();
  const location = props.location;
  const { id: email, token } =
    queryString && queryString.parse(location.search);
  const [messageApi, contextHolder] = message.useMessage();
  const password = useInput('');
  const confirm = useInput('');

  const changePassword = async () => {
    if (!token) {
      messageApi.error('인증정보가 잘 못 입력 되었습니다');
      return;
    }
    // window.location.replace(`/`);
    const tmpPwd = String(password.value || '').trim();
    const tmpConfirem = String(confirm.value || '').trim();

    if (tmpPwd.length > 0 && tmpPwd == tmpConfirem) {
      const response = await authApi.patch(`/admin/password?token=${token}`, {
        password: tmpPwd,
      });
      // console.log('--->', response.data);
      messageApi.info(
        (response && response.data) || '비밀번호 변경하는데 실패하였습니다.'
      );
      return;
    }
    messageApi.error('비밀번호가 잘 못 입력 되었습니다');
    // messageApi.error('비밀번호 변경하는데 실패하였습니다.');
  };

  const styles = {
    title: {
      marginTop: -72,
      marginLeft: 40,

      // font
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: '2.2rem',
    },
    password: {
      height: 32,
      width: 353,
      marginTop: 44,
      marginLeft: 16,
      border: 0,
    },
    confirm: {
      height: 32,
      width: 353,
      marginTop: 35,
      marginLeft: 16,
      border: 0,
    },
    button: {
      height: 34,
      width: 353,
      marginTop: 16,
      marginLeft: 16,
      background: '#7367F0',
    },
    link: {
      height: 32,
      width: 353,
      marginTop: 8,
      marginLeft: 16,
      // font
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2.2rem',
      color: '#7367F0',
    },
  };
  return (
    <div className="container">
      {contextHolder}
      <div className="topArea">
        <div className="topBox" style={{ marginTop: '1rem' }} />
        <div className="topBorderBox" style={{ marginLeft: '-5rem' }} />
      </div>
      <div style={{ height: '32rem' }} />
      <div className="bottomArea">
        <div className="bottomBorderBox" style={{ marginRight: '8rem' }}>
          <div className="bottomBox" />
        </div>
      </div>
      <div
        className="centerArea"
        style={{
          flexDirection: 'column',
          marginTop: '-65rem',
          marginLeft: '-8rem',
          backgroundImage: `url(${require('../../../../assets/images/bkg_pwd_change.png')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          paddingTop: '23rem',
          paddingLeft: '3.2rem',
        }}
      >
        <div style={{ ...styles.title }}>{email || '-'}</div>
        <Input.Password
          style={{ ...styles.password }}
          placeholder={'********'}
          className={'input'}
          allowClear
          // {...password}
          onChange={password.onChange}
        />
        <Input.Password
          style={{ ...styles.confirm }}
          placeholder={'********'}
          className={'input'}
          allowClear
          // {...password}
          onChange={confirm.onChange}
        />

        <Button
          type="primary"
          style={{
            ...styles.button,
          }}
          onClick={(e) => {
            // console.log('password');
            changePassword();
          }}
        >{`비밀번호 재설정 완료`}</Button>

        <Button
          type="link"
          style={{
            ...styles.link,
          }}
          onClick={(e) => {
            window.location.replace('/');
          }}
        >{`< 로그인 페이지로 돌아가기`}</Button>
      </div>
    </div>
  );
};

export default ChangePassword;
